<template>
  <div ref="switch" class="switch">
    <div v-for="(choice, key) in choices" class="choice" :key="key">
      <input
        type="radio"
        :checked="key === value"
        :name="name"
        :value="key"
        @change="selectSwitch"
      />
      <span :class="{ 'text-white': key === val }">{{ choice.label }}</span>
    </div>
    <div :style="{ left: left, width: width }" class="bar"></div>
  </div>
</template>

<script>
export default {
  name: "iSwitch",
  props: ["name", "choices", "value"],
  data() {
    return {
      val: this.value,
      left: 0,
      width: 0
    };
  },
  mounted() {
    this.selectSwitch();
  },
  methods: {
    selectSwitch() {
      const checked = this.$refs.switch.querySelector("input:checked");
      this.left = checked.parentElement.offsetLeft + "px";
      this.width = checked.parentElement.offsetWidth + "px";
      this.val = checked.value; // this.choices.map(item => item.value).indexOf(checked.value);
      this.$emit("input", this.val);
    }
  }
};
</script>

<style lang="scss">
.switch {
  position: relative;
  display: flex;
  padding: 0;
  margin-top: 16px;
  background: $white;
  border: 4px solid $white;
  border-radius: 27px;
  .choice {
    position: relative;
    //width: 8rem;
    z-index: 2;
    input {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      margin: 0;
      opacity: 0;
      user-select: none;
      cursor: pointer;
      & + span {
        color: $gray;
      }
      &:checked {
        & + span {
          color: $white;
        }
      }
    }
    span {
      display: block;
      padding: 16px 16px 12px;
      // width: 4rem;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
      transition: all 0.3s ease-in-out;
    }

    span.text-white {
      color: white !important;
    }
  }
  .bar {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    border-radius: 23px;
    background-color: $black;
    //width: 4rem;
    height: 46px;
    transition: all 0.3s ease-in-out;
    /* &.active {
      left: calc(14rem);
    } */
  }
}
</style>
